import FinopayLogo from "@zenith/assets/icons/FinopayLogo";
import React from "react";
import { Outlet } from "react-router-dom";

const OnboardingLayout = () => {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center  bg-[#F2F2F2] p-8">
      <div className="absolute top-5">
        <FinopayLogo />
      </div>
      <div className="form mt-10  flex w-full max-w-2xl justify-center md:w-4/5">
        <Outlet />
      </div>
    </div>
  );
};

export default OnboardingLayout;
